export const breadcrumbsLayoutByVariant = {
  desktop: {
    mt: 131,
    py: 28,
  },
  laptop: {
    mt: 151,
    py: 28,
  },
  mobile: {
    mt: 121,
    py: 16,
  },
  tablet: {
    mt: 89,
    py: 16,
  },
};
